/**
 * DI-3-F — the two spellings of one MD5 (story §4).
 *
 * The parser computed the file MD5 as hex (`parse/hashes.ts:md5Hex`) — the
 * manifest sends that hex (`UploadFileManifestEntry.md5` is "Base64 or hex";
 * the gateway's `upload-manifest-hash.ts` normalises both to hex), and the
 * commit sends it as BASE64 in the `Content-MD5` / `x-ms-blob-content-md5`
 * header (Azure's form). No file is read again for either.
 */

const HEX32 = /^[0-9a-f]{32}$/i;

/** "d41d8cd98f00b204e9800998ecf8427e" → "1B2M2Y8AsgTpgAmY7PhCfg==". */
export function md5HexToBase64(hex: string): string {
  if (!HEX32.test(hex)) throw new Error(`not an MD5 hex digest: ${hex}`);
  let bin = "";
  for (let i = 0; i < 32; i += 2)
    bin += String.fromCharCode(Number.parseInt(hex.slice(i, i + 2), 16));
  return btoa(bin);
}

/** Lower-case hex, as the manifest carries it. */
export function md5Hex(hex: string): string {
  if (!HEX32.test(hex)) throw new Error(`not an MD5 hex digest: ${hex}`);
  return hex.toLowerCase();
}
